import { getObjectByKeys } from '../../helpers';
import { useGlobalStore } from '../index';

import type { BaseCurrencyInterface } from 'sonata-static-storage/lib/schemas/baseCurrency/baseCurrency.schema';
import type { GlobalStore } from '../index';

// SETTERS
export const setBaseCurrency = useGlobalStore.getState().setBaseCurrency;

// GETTERS
export const getBaseCurrency = (store: GlobalStore) => {
  const { baseCurrency } = store;
  return baseCurrency;
};
export const getBaseCurrencyByKeys = (store: GlobalStore, keys: (keyof BaseCurrencyInterface)[]) =>
  getObjectByKeys(store.baseCurrency, keys);
